var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99981 0.692322C6.89072 0.692322 5.18095 2.41598 5.18095 4.54223C5.18095 6.66847 6.89072 8.39213 8.99981 8.39213C11.1089 8.39213 12.8187 6.66847 12.8187 4.54223C12.8187 2.41598 11.1089 0.692322 8.99981 0.692322Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5879 9.60789C4.4788 9.60789 2.76904 11.3316 2.76904 13.4578C2.76904 15.584 4.4788 17.3077 6.5879 17.3077H11.4117C13.5208 17.3077 15.2306 15.584 15.2306 13.4578C15.2306 11.3316 13.5208 9.60789 11.4117 9.60789H6.5879Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputPerson);
export default __webpack_public_path__ + "static/media/input-person.63e239b0201021e94d2577c78f8482fb.svg";
export { ForwardRef as ReactComponent };